export default __webpack_public_path__ + "static/media/1_Intro.d470914f.mp4";